module.exports = __webpack_public_path__ + "static/img/abeja_logo1.46a08ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/abeja_logo1.png
// module id = 257
// module chunks = 1